import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl, TextControl, ToggleControl, RangeControl, Flex, FlexBlock, FlexItem } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;


wp.blocks.registerBlockVariation('core/paragraph', {
    name: "counter",
    title: 'Counter',
    keywords: [ "counter", "number", "count", "stats" ],
    icon: 'image-rotate',
    isDefault: false,
    category: "text",
    scope: [ "inserter", "transform", "block" ],
    description: "Insert counter animation.",
    attributes: { className: "is-sp-counter", dataStart: 100, dataEnd: 300, prefix: '' },
    isActive: (e) => {
        if (e.className && e.className.includes('is-sp-counter')) {
            return true;
        }
        return false;
    },

});


// Enable spacing control on the following blocks
const enableCounterControlOnBlocks = [
    'core/paragraph',
];
/*eslint space-in-parens: ["error", "always"]*/


/**
 * Add spacing control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */
const addDataStartEndControlAttribute = (settings, name) => {
    // Do nothing if it's another block than our defined ones.
    if (!enableCounterControlOnBlocks.includes(name)) {
        return settings;
    }

    // Use Lodash's assign to gracefully handle if attributes are undefined
    settings.attributes = assign(settings.attributes, {

        counter: {
            type: 'boolean',
            default: false
        },
        dataStart: {
            type: 'string',
            default: 100
        },
        dataEnd: {
            type: 'string',
            default: 400
        },
        prefix: {
            "type": 'string',
            "default": ''
        }
    });

    return settings;
};

addFilter('blocks.registerBlockType', 'extend-block-example/couter/data', addDataStartEndControlAttribute);







/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withSpacingControl = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { setAttributes } = props;
        // console.log(props);
        // Do nothing if it's another block than our defined ones.
        if (!enableCounterControlOnBlocks.includes(props.name)) {
            return (
                <BlockEdit { ...props } />
            );
        }
        if (!(props.attributes.className && props.attributes.className.includes('is-sp-counter'))) {
            return (
                <BlockEdit { ...props } />
            )
        }
        return (
            <Fragment>
                <BlockEdit { ...props } />
                <InspectorControls>
                    <PanelBody
                        title={ __('Counter Settings') }
                        initialOpen={ true }
                    >
                        <ToggleControl label={ __("Counter?", 'sparkle-blocks') }
                            checked={ props.attributes.counter }
                            onChange={ (val) => setAttributes({ counter: val }) } />

                        { props.attributes.counter &&
                            <Fragment>
                                <Flex>
                                    <FlexBlock>
                                        <TextControl
                                            type="number"
                                            label={ __("Counter Start", 'sparkle-blocks') }
                                            min={ 1 }
                                            max={ 50000 }
                                            step={ 5 }
                                            className="counter-start"
                                            placeholder="Counter Start"
                                            value={ props.attributes.dataStart }
                                            onChange={ (val) => setAttributes({ dataStart: val }) }
                                        />
                                    </FlexBlock>
                                    <FlexBlock>
                                        <TextControl
                                            type="number"
                                            label={ __("Counter End", 'sparkle-blocks') }
                                            min={ 1 }
                                            className="counter-end"
                                            placeholder="Counter End"
                                            value={ props.attributes.dataEnd }
                                            onChange={ (val) => setAttributes({ dataEnd: val, content: val }) }
                                        />
                                    </FlexBlock>
                                </Flex>




                                <TextControl
                                    label={ __("Prefix", 'sparkle-blocks') }
                                    className="counter-prefix"
                                    placeholder="Counter Prefix"
                                    value={ props.attributes.prefix }
                                    onChange={ (val) => setAttributes({ prefix: val, content: props.attributes.dataEnd + val }) }
                                />
                            </Fragment>
                        }

                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, 'withSpacingControl');

addFilter('editor.BlockEdit', 'extend-block-example/with-counter-control', withSpacingControl);